/* Start redirect users to the correct market based on customer market tag */
function updateLocalization({
  country,
  language
}) {
  const formId = "market-form";
  const formHtml = `
      <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="country_code" value="${country}">
      <input name="language_code" value="${language}">
      </form>
  `;
  document.body.insertAdjacentHTML("beforeend", formHtml);
  document.getElementById(formId).submit();
}
if (!Shopify.designMode && window.marketDetails && window.marketDetails.customerMarket && window.marketDetails.currentCountry !== window.marketDetails.customerMarket && window.marketDetails.availableCountries.includes(window.marketDetails.customerMarket)) {
  updateLocalization({
    country: window.marketDetails.customerMarket,
    language: window.marketDetails.currentLanguage
  });
}
/* End market redirection */

// Collection quick add to cart
window.bindQuickAdd = function () {
  let quickAddToCarts = document.querySelectorAll('.quick-atc');
  quickAddToCarts.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      // Check if the element contains'data-plv'
      let productPLVAttr = e.target.closest('.ProductItem').getAttribute('data-plv');
      if (productPLVAttr) {
        // Get current user fidelity point
        let userFidelityPoints = Shopify.Customer.fidelity_amount;
        let productPLV = parseInt(productPLVAttr);

        // Check if user point are greater than the plv product price
        if (userFidelityPoints < productPLV) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          return; // If not enough point, function stopped here
        }
      }
      let data = {
        'id': parseInt(button.getAttribute('data-id')),
        'quantity': 1
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: 43239128793303,
            quantity: 1
          }
        }));
      }).catch(error => {
        console.error('Error:', error);
      });
    });
  });
};
window.bindQuickAdd();

/* CART */

document.addEventListener('cart:refresh', bindCartEvents);
document.addEventListener('product:added', bindCartEvents);
function bindCartEvents() {
  setTimeout(function () {
    // We need a setTimeout to wait for the cart to re-render

    // Cart items info fields

    let addInfoLinks = document.querySelectorAll('.CartItem__AddInfo');
    let infoFields = document.querySelectorAll('.CartItem__InfoField');
    addInfoLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        link.style.display = 'none';
        link.parentNode.querySelector('.CartItem__InfoField').style.display = 'block';
      });
    });

    // Add a property to the line item
    infoFields.forEach(function (field) {
      field.addEventListener('change', function () {
        let data = {
          'id': field.getAttribute('data-line-key'),
          'quantity': parseInt(field.getAttribute('data-line-quantity')),
          'properties': {
            'commentaire': field.value
          }
        };
        if (field.value == "") {
          data.properties['commentaire'] = null;
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        }).then(function () {
          console.log("Property added");
        }).catch(error => {
          console.error('Error:', error);
        });
      });
    });
  }, 500);
}

/* PAGES SECTIONS */

$(document).ready(function () {
  /* Slider for collabs in "our collections" page */
  $('.slider-with-text__slider-container').flickity({
    // options
    cellAlign: 'center',
    contain: true,
    groupCells: '100%'
  });

  /* Slider for our collections page */
  $('.page-slider__container').flickity({
    // options
    groupCells: 1,
    contain: true,
    selectedAttraction: 0.15,
    friction: 0.8
  });

  /* Job offers dropdown */
  $('.job-offer-dropdown__offers-title').click(function () {
    $(this).closest('.job-offer-dropdown__offers-container').find('.job-offer-dropdown__items').slideToggle(400);
    $(this).closest('.job-offer-dropdown__offers-container').find('.job-offer-dropdown__arrow').toggleClass('active');
  });
});

/* SHOW PASSWORD LOGIN */

const eye = document.querySelector('.Form__ItemShowPassword');
const password = document.querySelector('.Form__Input.login-password');
eye?.addEventListener('click', function () {
  if (password.type == 'password') {
    password.type = 'text';
  } else if (password.type == 'text') {
    password.type = 'password';
  }
});
document.addEventListener('cart:refreshed', function () {
  // Discount code
  if (sessionStorage.getItem('discountCode')) {
    if (document.querySelector('.Cart__DiscountButton')) {
      document.querySelector('.Cart__DiscountButton').innerHTML = sessionStorage.getItem('discountCode') !== '' ? window.languages.cartEditDiscount : window.languages.cartAddDiscount;
    }
    if (document.querySelector('.Cart__Discount')) {
      document.querySelector('.Cart__Discount').value = sessionStorage.getItem('discountCode');
      document.querySelector('.Cart__Discount').addEventListener('keydown', e => {
        if (e.keyCode == 13) {
          e.preventDefault();
          document.querySelector('.Cart__OffscreenDiscountContainer button').click();
        }
      });
    }
  }

  // Prevent cart submission of the form by clicking ‘Enter’ on discount code input.
  document.querySelector('.Cart__OffscreenDiscountContainer button')?.addEventListener('click', () => {
    sessionStorage.setItem("discountCode", document.querySelector('.Cart__Discount').value);
    if (window.freeGiftSettings?.isEnable == true) {
      handleFreeGift();
    }
  });

  // Prevent cart submission of the form by clicking ‘Enter’ on quantity input.
  document.querySelectorAll('#sidebar-cart .QuantitySelector__CurrentQuantity').forEach(quantityInput => {
    quantityInput.addEventListener('keydown', e => {
      if (e.keyCode == 13) {
        e.preventDefault();
        e.stopPropagation();
        e.target.blur();
      }
    });
  });

  // freegift
  if (window.freeGiftSettings?.isEnable == true) {
    handleFreeGift();
  } else if (window.freeGiftSettings?.isEnable == false) {
    let freeGiftInCart = false;
    document.querySelectorAll('.CartItem').forEach(item => {
      if (item.hasAttribute('data-freegift-in-cart')) {
        freeGiftInCart = true;
      }
    });
    if (freeGiftInCart == true) {
      fetch('/cart.js').then(response => response.json()).then(data => {
        let freeGift = data.items.find(variant => window.freeGiftSettings.freeGiftVariant == variant.id);
        let updateQuantity = -freeGift.quantity;
        removeFreeGift(window.freeGiftSettings.freeGiftVariant, freeGift.quantity, updateQuantity);
      });
    }
  }
});
function handleFreeGift() {
  fetch('/cart.js').then(response => response.json()).then(data => {
    // check if the free gift product is in the cart
    let priceThreshold = parseInt(window.freeGiftSettings.freeGiftThreshold);
    let minimumProductWithTag = parseInt(window.freeGiftSettings.minimumProductWithTag);
    let accumulateFreeGift = window.freeGiftSettings.accumulateFreeGift;
    let cartAmount = parseFloat(document.querySelector('[data-total-price]')?.getAttribute('data-total-price').replace(/,/g, ''));
    let freeGift = data.items.find(variant => window.freeGiftSettings.freeGiftVariant == variant.id);
    let freeGiftInCart = data.items.find(variant => window.freeGiftSettings.freeGiftVariant == variant.id) !== undefined;

    // Init variable
    let freeGiftQuantity = 0;
    let taggedProductInCart = false;
    let currentDiscount;
    if (document.querySelector('.Cart__Discount')) {
      currentDiscount = document.querySelector('.Cart__Discount').value;
    }
    ;

    // Init array
    let eligibleProduct = [];
    let eligibleProductQuantity = [];

    // when the freegift is on the cart we can get the quantity of it, quantity initialize at 0 if the freegift is not in the cart
    if (freeGift) {
      freeGiftQuantity = freeGift.quantity;
    }
    ;

    // check for each item if it has the property 'freeGiftEligible', if it the case, each item is push into eligibleProduct array, and check if properties exist, avoid error if we use the threshold
    data.items.forEach(item => {
      if (item.properties?.freeGiftEligible !== undefined) {
        eligibleProduct.push(item);
        return taggedProductInCart = true;
      }
      ;
    });

    // Then for each item in the eligibleProduct array, we extract only the quantity and push it into another array: eligibleProductQuantity
    eligibleProduct.forEach(function (item) {
      eligibleProductQuantity.push(item.quantity);
    });

    // We intialize the value to 0 and then reduce the array, it give us the total quantity of item with the property 'freeGiftEligible' in the cart
    const initialValue = 0;
    let sumWithInitial = '';
    let updateQuantity = 0;
    let checkThreshold = '';
    let freegiftMode = '';
    let freeGiftDiscount = false;

    // Check if the current discount code corresponds to the one set in the settings
    if (currentDiscount == window.freeGiftSettings.discountCode || window.freeGiftSettings.discountCode == '') {
      freeGiftDiscount = true;
    }
    ;

    // If we use tags, we check the freegift mode and if the input is not blank
    if (window.freeGiftSettings.productTag != undefined && window.freeGiftSettings.freeGiftMode == 'tags') {
      sumWithInitial = eligibleProductQuantity.reduce((accumulator, currentValue) => accumulator + currentValue, initialValue);
      // making difference between the quantity of product with the property 'freeGiftEligible' and the freegift quantity, if the sum is smaller than the minimum ammount, we set to -1.
      if (sumWithInitial >= minimumProductWithTag && accumulateFreeGift != false) {
        updateQuantity = sumWithInitial - freeGiftQuantity;
      } else {
        updateQuantity = -1;
      }
      ;
      freegiftMode = 'tags';
    }
    ;

    // if we use threshold, update quantity is always == -1 because only one freeGift is add on the cart in this case, we check the freegift mode and if the input is not blank
    if (priceThreshold >= 0 && window.freeGiftSettings.freeGiftMode == 'threshold') {
      checkThreshold = !freeGiftInCart && priceThreshold <= cartAmount;
      updateQuantity = -1;
      freegiftMode = 'threshold';
    }
    ;

    /* only if the free gift isn't in the cart and the tags correspond the freegift is added and the sum of it is greater than the number minimum set in the settings
      OR 
      if the threshold is lower than the cart amount or if the discount code corresponds with the code set in the settings  
    */
    if (!freeGiftInCart && freeGiftDiscount && (taggedProductInCart && freegiftMode == "tags" && sumWithInitial >= minimumProductWithTag || checkThreshold && freegiftMode == "threshold")) {
      addFreeGift(data.items, freegiftMode);
    }

    // else if the tags corresponds and the difference between the quantity of product with the property 'freeGiftEligible' and the freegift quantity is > 0, freegift quantity will be increased, only if the "accumulate freegift" settings is true
    else if (taggedProductInCart && freeGiftDiscount && updateQuantity > 0 && freegiftMode == "tags" && accumulateFreeGift == true) {
      // we give to the function the freegift, freegift quantity, and difference between product tagged and freegift
      increaseFreeGiftQuantity(window.freeGiftSettings.freeGiftVariant, freeGiftQuantity, updateQuantity);
    }

    // First we check if the freegift is in the cart
    /* else if the tags corresponds and the difference between the quantity of product with the property 'freeGiftEligible' and the freegift quantity is < 0, freegift quantity will be decreased
      OR 
        if we don't accumulate the freegift the freegift is removed
      OR
        if the price threshold is greater than the cart amount, and the freegift is in the cart and the new freegift quantity is < 0, freegift will be removed
      OR 
        if the quantity of the freegift > 1 and we switch to the threshold mode or don't accumulate the freegift, the quantity of freegift will be reset to 1
      OR 
        if the discount code is not the same as the one setup in the settings, freegift is removed.
    */else if (freeGiftInCart && ((updateQuantity < 0 && accumulateFreeGift == true || accumulateFreeGift == false && (sumWithInitial < minimumProductWithTag || !taggedProductInCart)) && freegiftMode == "tags" || priceThreshold > cartAmount && updateQuantity < 0 && freegiftMode == "threshold" || (freegiftMode == "threshold" || freegiftMode == "tags" && accumulateFreeGift == false) && freeGift.quantity > 1 || !freeGiftDiscount)) {
      // Set the update quantity to remove all the freegift if the discount is not the correct one, or if th minimum of product with tag is greater than the sum of the product with the tag
      if (!freeGiftDiscount || freegiftMode == "tags" && sumWithInitial < minimumProductWithTag) {
        updateQuantity = -freeGift.quantity;
      }
      ;

      // Reset to 1 the freegift if we don't accumulate the freegift, or if we switch to the treshold mode
      if (freeGift.quantity > 1 && (accumulateFreeGift == false && sumWithInitial > minimumProductWithTag || freegiftMode == "threshold")) {
        updateQuantity = -freeGift.quantity + 1;
      }
      ;

      // we give to the function the freegift, freegift quantity, and difference between product tagged and freegift
      removeFreeGift(window.freeGiftSettings.freeGiftVariant, freeGiftQuantity, updateQuantity);
    }
    ;
  });
}
;
function addFreeGift(items, freegiftMode) {
  items.forEach(item => {
    jQuery.getJSON(window.Shopify.routes.root + 'products/' + item.handle + '.js', function (product) {
      /* check for each item if the tag write in the settings is in the product tags, if true add the free product in the cart 
        OR 
        check if the threshold is smaller than the total amount of the cart    
      */
      if (product.tags.includes(window.freeGiftSettings.productTag) && freegiftMode == "tags" || parseInt(window.freeGiftSettings.freeGiftThreshold) <= parseInt(document.querySelector('[data-total-price]')?.getAttribute('data-total-price')) && freegiftMode == "threshold") {
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        let data = {
          'id': window.freeGiftSettings.freeGiftVariant,
          'quantity': 1,
          'properties': {
            '_linkedVariant': product.id
          }
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        }).then(function () {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: 43239128793303,
              quantity: 1
            }
          }));
        }).catch(error => {
          console.error('Error:', error);
        });
      }
      ;
    });
  });
}
;
function increaseFreeGiftQuantity(lineId, quantity, increasedQuantity) {
  // here we added the number when we have more product eligible than freegift in the cart
  let updateData = {
    updates: {
      [lineId]: quantity + increasedQuantity
    }
  };

  // Remove item
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updateData)
  }).then(response => response.json()).then(() => {
    // Refresh the cart
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }).catch(error => {
    console.error('Error: ', error);
  });
}
;
function removeFreeGift(lineId, quantity, decreasedQuantity) {
  // here we added the number when we have less product eligible than freegift in the cart, the value of decreaseQuantity will be negative that's why we adding it to the quantity, for e.g. ([lineId] : 4 + (-2) = 2, so the freegift quantity will decreased by 2) 
  let updateData = {
    updates: {
      [lineId]: quantity + decreasedQuantity
    }
  };

  // Remove item
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(updateData)
  }).then(response => response.json()).then(() => {
    // Refresh the cart
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  }).catch(error => {
    console.error('Error: ', error);
  });
}
;